import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const BasicInfoIcon2 = (props: SvgProps) => (
  <Svg
    width={74}
    height={33}
    fill="none"
    {...props}
  >
    <Path
      stroke="#C0A46F"
      strokeWidth={1.5}
      d="M.25 1.253c27.418 9.73 51.688 19.949 73 30.482"
    />
  </Svg>
)
export default BasicInfoIcon2
